/**
 * Order Domain Errors
 *
 * Typed errors for order operations.
 * Allows for precise error handling in use cases and UI.
 */

export type OrderErrorCode =
  | 'CREATE_FAILED'
  | 'VALIDATION_FAILED'
  | 'CITY_NOT_FOUND'
  | 'PAYMENT_FAILED'
  | 'DELIVERY_UNAVAILABLE'
  | 'CALCULATE_TOTALS_FAILED'
  | 'UNKNOWN'

export class OrderError extends Error {
  readonly code: OrderErrorCode
  readonly cause?: unknown

  constructor(code: OrderErrorCode, cause?: unknown) {
    super(OrderError.getMessageForCode(code))
    this.name = 'OrderError'
    this.code = code
    this.cause = cause
  }

  private static getMessageForCode(code: OrderErrorCode): string {
    const messages: Record<OrderErrorCode, string> = {
      CREATE_FAILED: 'Failed to create order',
      VALIDATION_FAILED: 'Order validation failed',
      CITY_NOT_FOUND: 'City not found for location',
      PAYMENT_FAILED: 'Payment processing failed',
      DELIVERY_UNAVAILABLE: 'Delivery is not available',
      CALCULATE_TOTALS_FAILED: 'Failed to calculate order totals',
      UNKNOWN: 'Unknown order error',
    }
    return messages[code]
  }
}
